module.exports = __webpack_public_path__ + "static/media/back-red.fbaec539.png";